import actions from '@/config/actions';
import mutations from '@/config/mutations';
import ApiService from '@/service/apiService';
import Api from '@/config/api';

export default {
    state: {
        sentContacts: [],
        receivedContacts:[],
        hiddenContacts: [],
        userResponseModel: [],
        showHidden: null,
        repliedContactCount: null,
        searchModal: false,
        sentContactsPagination: {},
        sentSearchParams: {},
        loading: false,
        sentPage: 1,
        receivedStatusModel: [],
        sentStatusModel: []
    },
    mutations: {
        setSentContacts(state, payload) {
            state.sentContacts = payload;
        },
        setReceivedContacts(state, payload) {
            state.receivedContacts = payload;
        },
        setHiddenContacts(state, payload) {
            state.hiddenContacts = payload;
        },
        toggleHiddenContacts(state,payload) {
            state.showHidden = !state.showHidden;
        },
        setRepliedContactCount(state, payload) {
            state.repliedContactCount = payload;
        },
        clearAll(state){
            state.sentContacts = [];
            state.receivedContacts = [];
            state.hiddenContacts = [];
        },
        toggleSearchModal(state, payload){
            state.searchModal = payload;
        },
        setSentContactsPagination(state, payload){
            state.sentContactsPagination = payload;
        },
        setSentSearchParams(state, payload){
            state.sentSearchParams = payload;
        },
        setLoading(state, payload){
            state.loading = payload;
        },
        setSentPage(state, payload){
            state.sentPage = payload;
        },
        setUserResponseModel(state, payload){
            state.userResponseModel = payload;
        },
        setReceivedStatusModel(state, payload){
            state.receivedStatusModel = payload;
        },
        setSentStatusModel(state, payload){
            state.sentStatusModel = payload;
        },
        mutateSentListAfterInterview(state, contact) {
            // console.log(contact);
            const newApplicants = state.sentContacts.map((app) => {
              if (contact.id === app.receiver._id) {
                // console.log('found');
                app.receiver.isInterview = contact.isInterview;
              }
              return app;
            });
            state.sentContacts = [];
            state.sentContacts = newApplicants;
        },

    },
    getters: {
        getSentContacts(state){
            return state.sentContacts;
        },
        getReceivedContacts(state){
            return state.receivedContacts;
        },
        getHiddenContacts(state){
            return state.hiddenContacts;
        },
        getShowHidden(state){
            return state.showHidden;
        },
        getRepliedContactCount(state){
            return state.repliedContactCount;
        },
        getSearchModal(state){
            return state.searchModal;
        },
        getSentContactsPagination(state){
            return state.sentContactsPagination;
        },
        getSentSearchParams(state){
            return state.sentSearchParams;
        },
        getLoading(state){
            return state.loading;
        },
        getUserResponseModel(state){
            return state.userResponseModel;
        },
        getReceivedStatusModel(state){
            return state.receivedStatusModel;
        },
        getSentStatusModel(state){
            return state.sentStatusModel;
        }
    },
    actions: {
        loadSentContacts(context, params = {}){
            return ApiService.get(Api.endpoints.LIST_MESSAGES, {}, params);
        },
        loadReceivedContacts(context, params = {}){
            return ApiService.get(Api.endpoints.LIST_REPLIED_MESSAGES, {}, params);
        },
        async loadReceivedContactsCount(context) {
            try {
                const contactCount = await ApiService.get(Api.endpoints.REPLIED_MESSAGES_COUNT);
                context.commit('setRepliedContactCount', contactCount.data.data);
            } catch(err) {
                console.log(err);
            }
        }
    }
}